import React from 'react';
interface LogoProps {
  className?: string;
  variant?: 'full' | 'icon';
}
export function Logo({
  className = '',
  variant = 'full'
}: LogoProps) {
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-98">
      {/* Geometric D icon */}
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-99">
        <rect width="36" height="36" rx="8" fill="#10b981" data-id="element-100" />
        <path d="M12 10h6c4.418 0 8 3.582 8 8s-3.582 8-8 8h-6V10z" fill="white" data-id="element-101" />
        <circle cx="18" cy="18" r="3" fill="#10b981" data-id="element-102" />
      </svg>

      {variant === 'full' && <span className="text-2xl font-bold text-slate-900" data-id="element-103">Domisafe</span>}
    </div>;
}